import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ProductSupportWidgetComponent} from './product-support-widget.component';
import {MatSidenavModule} from '@angular/material/sidenav';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductSupportWidgetComponent: {
          component: ProductSupportWidgetComponent,
        },
      },
    }),
    I18nModule,
    CommonModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    ProductSupportWidgetComponent,
  ],
  exports: [ProductSupportWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductSupportWidgetModule {}
